import { resolveUserId } from '~/utils/analytics/user-id';

export default ({ store }, inject) => {
  // GTM is now loaded via manual script, so we don't need to check env.GTM_ID
  /**
   * @param {string} eventName nombre del evento
   * @param {object=} newData  forma vieja, la que leen las etiquetas publicadas hoy
   * @param {object=} ecommerce bloque de comercio electrónico de GA4, con `items`.
   *   Va en la RAÍZ del push: GA4 no lo lee de ningún otro lado.
   */
  const dataLayerPush = async (eventName, newData, ecommerce) => {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    // Reset antes de CADA evento (VEX-6460). El modelo de datos de GTM fusiona
    // cada push sobre el estado anterior en vez de reemplazarlo —los objetos
    // clave por clave y los arrays posición por posición—, así que sin esto las
    // claves de un evento se siguen resolviendo en el siguiente: `data.purchase`
    // quedaba disponible después de una compra para cualquiera de las etiquetas
    // que disparan más tarde en la misma página.
    //
    // Reemplaza al `dataLayerPush({ data: null })` que corría una sola vez al
    // cargar el plugin y además estaba mal armado: el primer argumento es el
    // NOMBRE del evento, así que empujaba `{ event: {data: null}, data: undefined }`.
    window.dataLayer.push({ ecommerce: null, data: null });

    // El usuario se relee aca, no al cargar el plugin: cuando el plugin corre
    // todavia no hay sesion (VEX-6458). La clave viaja siempre, incluso en
    // undefined, para limpiar el modelo del dataLayer al desloguear.
    window.dataLayer.push({
      event: eventName,
      data: newData,
      user_id: resolveUserId(store.state.auth.user, newData),
      ...(ecommerce ? { ecommerce } : {})
    });
    return;
  };

  inject('dataLayerPush', dataLayerPush);
};
